import { OrganizationContactPerson } from '@common/entities';

// A contact is identified by the relationship, rather than the underlying person.
export type ContactPersonListItemDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  personId: string;
  organizationId: string;
  organizationName: string;
  organizationType: string;
  organizationSubType?: string;
  firstName: string;
  lastName: string;
  name: string;
  academicTitle?: string;
  email?: string;
  phoneNumber?: string;
  qualifications: string[];
  media: string[];
  addressCo?: string;
  addressStreetAndNumber: string;
  addressPostalCode: string;
  addressCity: string;
  addressFederalState: string;
};

export function toContactPersonListItem(contact: OrganizationContactPerson): ContactPersonListItemDto {
  const { person, organization } = contact;
  return {
    id: contact.id,
    createdAt: contact.createdAt,
    updatedAt: contact.updatedAt,
    personId: contact.personId,
    organizationId: contact.organizationId,
    organizationName: organization?.name || '',
    organizationType: organization?.type,
    organizationSubType: organization?.subType,
    firstName: person?.firstName || '',
    lastName: person?.lastName || '',
    name: person?.name || '',
    academicTitle: person?.academicTitle,
    email: contact.email || '',
    phoneNumber: contact.phoneNumber || '',
    qualifications: contact.qualifications || [],
    media: contact.media || [],
    addressCo: organization?.addressCo,
    addressStreetAndNumber: organization?.addressStreetAndNumber || '',
    addressPostalCode: organization?.addressPostalCode || '',
    addressCity: organization?.addressCity || '',
    addressFederalState: organization?.addressFederalState || '',
  };
}
